import {
  ApiResponseError,
  ApiSessionTimeoutError,
  classifyApiError,
  unwrapResponseModel
} from '../api/responseModel';

export {
  ApiResponseError as AlumnoCarreraApiError,
  ApiSessionTimeoutError as AlumnoCarreraSessionTimeoutError,
  classifyApiError as classifyAlumnoCarreraError,
  unwrapResponseModel
};

export function currentEnrollmentYear() {
  return String(new Date().getFullYear());
}

export function isValidAnioInicioCarrera(anio) {
  const value = String(anio ?? '').trim();
  if (!/^\d{4}$/.test(value)) {
    return false;
  }
  const year = parseInt(value, 10);
  return year >= 1900 && year <= 2100;
}

export function toSaveAlumnoCarreraPayload(tags, alumnoCodigo, anioInicio) {
  const year = parseInt(anioInicio, 10);
  return tags.map((tag) => ({
    AlumnoCodigo: parseInt(alumnoCodigo, 10),
    CarreraCod: parseInt(tag.id, 10),
    AlumnoxCarreraAnioInicio: year,
  }));
}

export function toUpdateAlumnoCarreraPayload({ id, alumnoCodigo, carreraCod, anioInicio }) {
  return {
    alumnoCodigo,
    carreraCod,
    alumnoxCarreraCod: parseInt(id, 10),
    alumnoxCarreraAnioInicio: parseInt(anioInicio, 10),
  };
}

export function toInscribirAlumnoPayload({ nombre, dni, carrerasCod }) {
  return {
    AlumnoNombre: nombre,
    AlumnoDni: dni,
    CarrerasCod: carrerasCod
  };
}

export function validateAlumnoCarreraForm({ alumnoCodigo, tagCount }) {
  return Boolean(alumnoCodigo?.length > 0 && tagCount > 0);
}

export function validateInscribirAlumnoForm({ dni, nombre, tagCount }) {
  return Boolean(dni?.length > 0 && nombre?.length > 0 && tagCount > 0);
}
